import { setCurrentHotspot } from "../../redux";
import { useDispatch } from "react-redux";
import FlatSquareButton from "../FlatSquareButton/FlatSquareButton";
import ArrowLeftIcon from "remixicon-react/ArrowLeftSLineIcon";
import { iconSize } from "../../config";

export const HotspotBackButton = () => {
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(setCurrentHotspot(null));
  };
  return (
    <FlatSquareButton onClick={onClose}>
      <ArrowLeftIcon size={iconSize} />
    </FlatSquareButton>
  );
};
